import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { setTheme, setUserData } from "../Header/LoginModalSlice";
import React, { Suspense } from "react";
import { Helmet } from "react-helmet";
import Header from "@sanchhaya_education_pvt_ltd/gfg-header/build/header";
import SubHeader from "@sanchhaya_education_pvt_ltd/gfg-header/build/subHeader";
import "@sanchhaya_education_pvt_ltd/gfg-header/build/header.css";
import { headerConfig, stickyStyles } from "./constants";

export default function AuthHeader({
  headerData,
  subHeaderData,
  fixMainHeader,
  headerScripts,
  subHeaderSticky,
  headerSticky = false,
  applyShadow = false,
  showNotifications,
  showSearch,
  showTranslate,
}) {
  const [toggleDarkTheme, setToggleDarkTheme] = useState(false);

  const dispatch = useDispatch();
  const setData = (data) => {
    dispatch(setUserData(data));
  };

  useEffect(() => {
    document.body.addEventListener(
      "click",
      (evt) => {
        if (
          typeof evt.target?.className?.includes === "function" &&
          evt.target?.className?.includes("login-modal-btn")
        ) {
          evt.preventDefault();
          document.querySelector(".gfg_loginModalBtn")?.click();
        }
      },
      false
    );
  }, []);

  useEffect(() => {
    if (toggleDarkTheme) {
      dispatch(setTheme("dark"));
    } else {
      dispatch(setTheme("light"));
    }
  }, [toggleDarkTheme, dispatch]);

  const url = new URL(window?.location?.href);

  return (
    <div
      className="gfg_header_wrapper"
      style={headerSticky ? stickyStyles : {}}
    >
      {url?.hostname === "practice.geeksforgeeks.org" && (
        <Helmet>
          <link
            rel="canonical"
            href={`https://www.geeksforgeeks.org${url?.pathname}${url?.search}${url?.hash}`}
          />
        </Helmet>
      )}
      <Suspense>
        <Header
          setToggleDarkTheme={setToggleDarkTheme}
          setUserData={setData}
          headerData={headerData}
          headerScripts={headerScripts}
          subHeaderData={subHeaderData}
          fixMainHeader={fixMainHeader}
          applyShadow={!subHeaderData ? applyShadow : false}
          headerConfig={{
            ...headerConfig,
            showNotifications,
            showTranslate,
            showSearch,
          }}
          promotionsMenu={{
            Courses: {
              pill: '<div style="background: 0% 0% no-repeat padding-box padding-box #3e63ad; position: absolute;border-radius: 4px; font-size: 12px; color: white; padding: 2px 5px !important; top: -11px; left:11%">Get 90% Refund</div>',
            },
          }}
          promotionsSubMenu={{
            "Job-A-Thon: Matrix Partners India": {
              itemTextColor: {
                light: "#3289D4",
                dark: "#3289D4",
              },
              itemBgColor: {
                light: "#ECFCFF",
                dark: "#ECFCFF",
              },
            },
            "GATE 2025 Scholarship Test": {
              itemTextColor: {
                light: "#3289D4",
                dark: "#3289D4",
              },
              itemBgColor: {
                light: "#ECFCFF",
                dark: "#ECFCFF",
              },
            },
            "Get Hired: Apply for Jobs": {
              itemTextColor: {
                light: "#3289D4",
                dark: "#3289D4",
              },
              itemBgColor: {
                light: "#ECFCFF",
                dark: "#ECFCFF",
              },
            },
          }}
        />
        {subHeaderData ? (
          <SubHeader
            subHeaderData={subHeaderData}
            changeDarkTheme={setToggleDarkTheme}
            style={subHeaderSticky ? stickyStyles : {}}
            isDarkTheme={toggleDarkTheme}
          />
        ) : null}
      </Suspense>
    </div>
  );
}
